import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxButtonModule } from '../rx-button/rx-button.module';
import { RxUploadThumbnailComponent } from './rx-upload-thumbnail/rx-upload-thumbnail.component';

@NgModule({
  imports: [CommonModule, RxButtonModule, RxUploadThumbnailComponent],
  exports: [RxUploadThumbnailComponent],
})
export class RxUploadThumbnailModule {}
